import React, { useEffect, useState } from "react";
import { Button, Spinner, Modal, Form } from "react-bootstrap";
import { createResources, getResources } from "../../services/Admin/adminServices";
import { Formik } from "formik";
import toast from "react-hot-toast";
import RichTextEditor from "../components/Common/RichTextEditor";

const Resources = () => {
  const [info, setInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
 const [selectedInfo, setSelectedInfo] = useState(null);
  const fetchData = async () => {
    try {
      const response = await getResources();

      setInfo(response?.data?.data);
    } catch (error) {
      console.error("Error fetching documentation info:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleSave = async (values) => {
    try {
      await createResources(values); // call update API
      toast.success("updated")
     fetchData();
      setShowModal(false);
    } catch (err) {
      console.error("Update failed:", err);
      toast.error(err?.response?.data?.message)
    }
  };

   const handleEditClick = (info) => {
    setSelectedInfo(info);
    setShowModal(true);
  };

  return (
    <div className=" ">
      <h3 className="mb-4" style={{color:"#0AB7EA"}}>Resources</h3>

      {loading ? (
        <div className="d-flex justify-content-center my-5">
          <Spinner animation="border" variant="primary" />
        </div>
      ) : !info ? (
        <p>No documentation info available.</p>
      ) : (
        <ul>
          <ul className="list-group">
            {info?.map((item) => (
              <li
                key={item._id}
                className="list-group-item d-flex justify-content-between align-items-center"
                style={{ borderColor: "#0AB7EA" }}
              >
                <div>

                  
              <div className="d-flex justify-content-between align-items-center w-100" >
               <div>
                  <h2 className="fw-bold  " style={{fontSize:"50px"}} >{item.title}</h2>
               </div>
                <div>
                   <button
                  className="btn btn-sm"
                  style={{
                    backgroundColor: "#0AB7EA",
                    color: "white",
                    border: "none",
                  }}
                      onClick={() => handleEditClick(item)}
                >
                  Edit
                </button> </div></div>

 
                <p className="desc-text" dangerouslySetInnerHTML={{ __html: item.description }} />
                </div>
               
              </li>
            ))}
          </ul>
        </ul>
      )}

      {/* Edit Modal */}
    {selectedInfo&&(  <Modal show={showModal} onHide={() => setShowModal(false)} dialogClassName="rich-editor-modal">
        <Modal.Header closeButton>
          <Modal.Title className="titleColor">Edit Resource</Modal.Title>
        </Modal.Header>
        <Formik
          initialValues={{
            title: selectedInfo?.title || "",
            description: selectedInfo?.description || "",
          }}
          enableReinitialize
          onSubmit={handleSave}
        >
          {({ handleChange, handleSubmit, values,setFieldValue }) => (
            <Form onSubmit={handleSubmit}>
              <Modal.Body>
                <Form.Group className="mb-3">
                  <Form.Label>Title</Form.Label>
                  <Form.Control
                    type="text"
                    name="title"
                    value={values.title}
                    onChange={handleChange}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Description</Form.Label>
                <RichTextEditor
                  value={values.description}
                  onChange={(content) => setFieldValue("description", content)}
                  placeholder="Write the resource description..."
                />
                </Form.Group>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={() => setShowModal(false)}>
                  Cancel
                </Button>
                <Button type="submit" style={{ backgroundColor: "#0AB7EA", border: "none" }}>
                  Save Changes
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>)}
    </div>
  );
};

export default Resources;
